import { create } from 'zustand'

type CurrentRecordingTTL = {
    value: number
    updatedAt: number // we want to update CurrentRecordingTTL as an object as there are components that depend on it
}

export interface AudioBatch {
    id: number
    blob: Blob
    mimeType: string
    createdAt: number
}

interface AudioState {
    mediaRecorder: MediaRecorder | undefined
    currentRecordingTTL: CurrentRecordingTTL | undefined
    selectedMicrophoneDeviceId: string | undefined
    audioBatches: AudioBatch[]
}

export const useAudioStore = create<AudioState>(() => ({
    mediaRecorder: undefined,
    currentRecordingTTL: undefined,
    selectedMicrophoneDeviceId: localStorage.getItem('selectedMicrophoneDeviceId') || undefined,
    audioBatches: [],
}))
